import { useQuery } from "@tanstack/react-query";
import { SubModel } from "model";

import { fetchPreferredSubs, type FetchPreferredSubsFn, type PreferredSubRequest } from "~utils";

type useSubsParams = {
  query: string;
  request: PreferredSubRequest;
  fetchFn?: FetchPreferredSubsFn;
  enabled?: boolean;
};

export function useSubs(params: useSubsParams) {
  const { request, fetchFn = fetchPreferredSubs, query, enabled = true } = params;

  const {
    isError,
    data: subs,
    isLoading,
  } = useQuery<SubModel[]>({
    queryKey: ["subs", "preferred", request, query],
    queryFn: async () => {
      if (!request.school) return [];

      const data = await fetchFn({ req: request, query });
      return data?.data?.map((sub) => new SubModel(sub)) || [];
    },
    staleTime: Infinity,
    enabled,
  });

  return { isError, subs: subs ?? [], isLoading };
}
